import { AlternativeTransportPlansResponse } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/useAlternativeTransportPlans";
import { Nullish } from "shared/utils/objectUtils";

const CLEANUP_KEYTYPES = new Set(["muteHistory", "lastAcknowledgedUpdate"]);

export function cleanUpMeasureOverviewLocalStorage(
  response: Nullish<AlternativeTransportPlansResponse>,
) {
  if (!response) return;

  const activeUuids = new Set(
    [
      ...Object.values(response.infrastructure),
      ...Object.values(response.train),
    ]
      .flat()
      .map((e) => e.information.uuid),
  );

  // eslint-disable-next-line no-plusplus -- have to enumerate by index
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);

    if (key && key.includes(":")) {
      const [keyType, uuid] = key.split(":");

      if (CLEANUP_KEYTYPES.has(keyType) && !activeUuids.has(uuid)) {
        localStorage.removeItem(key);
      }
    }
  }
}
